module.exports = __webpack_public_path__ + "static/media/exyookay-how-to-edited.bed8e0cd.png";